import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getAuthState } from '../utils/session';

// 로그인 필요 라우트를 감싸는 보호 컴포넌트.
// 세션 표시가 있어도 계정 오브젝트가 유효하지 않으면 인증 실패로 취급해
// 렌더 이전에 /Login 으로 replace 한다.
// requireAdmin 이 true 이면 관리자 세션만 허용한다.
// mobile 이 true 이면 실패 시 /mobile 로 이동한다.
export default function RequireAuth({ children, requireAdmin = false, mobile = false }) {
    const { isValid, isAdmin } = getAuthState();
    const location = useLocation();
    const loginPath = mobile ? '/mobile' : '/Login';

    if (!isValid) {
        return <Navigate to={loginPath} replace state={{ from: location.pathname }} />;
    }
    if (requireAdmin && !isAdmin) {
        return <Navigate to={loginPath} replace state={{ from: location.pathname }} />;
    }
    if (!requireAdmin && isAdmin) {
        // 관리자 계정이 사용자 화면 접근 시 관리자 홈으로 유도
        return <Navigate to="/AdminSetting" replace />;
    }
    return children;
}
